<template>
  <div style="postion: relative" v-if="false">
    <google-autocomplete
      outlined
      :country="['ca', 'us']"
      ref="address"
      id="map"
      :api-key="'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0'"
      prepend-icon="mdi-map"
      label="Type Your Address *"
      placeholder
      @place_changed="getAddressData"
      :rules="fieldRules"
    />
  </div>
  <v-card :class="cardClass" class="h-100" v-else>
    <v-card-title class="mb-5 primary white--text"> Address </v-card-title>
    <v-card-text class="pb-0">
      <v-form ref="addressUpdate">
        <google-autocomplete
          :country="['ca', 'us']"
          ref="address"
          id="map"
          :api-key="'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0'"
          prepend-icon="mdi-map"
          label="Enter a location *"
          placeholder
          @place_changed="getAddressData"
          :rules="fieldRules"
        />
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Apt/Suite #"
              type="text"
              v-model="addressTwo"
              :class="foundData ? 'visible' : 'hidden'"
            />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Street Address"
              type="text"
              disabled
              :class="foundData ? 'visible' : 'hidden'"
              v-model="addressOne"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="City"
              type="text"
              disabled
              :class="foundData ? 'visible' : 'hidden'"
              v-model="city"
            />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Province/State"
              type="text"
              disabled
              :class="foundData ? 'visible' : 'hidden'"
              v-model="province"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Postal/Zip Code"
              type="text"
              disabled
              :class="foundData ? 'visible' : 'hidden'"
              v-model="postalCode"
            />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Country"
              type="text"
              disabled
              :class="foundData ? 'visible' : 'hidden'"
              v-model="country"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="px-5 pb-5">
      <v-spacer />
      <v-btn @click="submit" color="primary" depressed>Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Parse from 'parse'
import { mapActions, mapGetters } from 'vuex'
import validationRules from '@/validation-rules'

export default {
  props: {
    cardClass: {
      type: String,
      default: ''
    },
    runAlert: Function
  },
  computed: mapGetters(['user']),
  data () {
    return {
      foundData: true,
      addressOne: '',
      addressTwo: '',
      postalCode: '',
      city: '',
      province: '',
      country: '',
      latitude: '',
      longitude: '',
      ...validationRules
    }
  },
  methods: {
    ...mapActions(['updateUser', 'toggleDialog', 'getUser']),
    getAddressData (addressData) {
      console.log(addressData)
      this.addressOne = addressData.name
      this.postalCode = addressData.postal_code
      this.city = addressData.locality
      this.province = addressData.administrative_area_level_1
      this.country = addressData.country
      this.latitude = addressData.latitude
      this.longitude = addressData.longitude
      this.foundData = true
    },
    async submit () {
      if (this.$refs.addressUpdate.validate()) {
        await this.updateUser({
          addressOne: this.addressOne,
          addressTwo: this.addressTwo,
          postalCode: this.postalCode,
          city: this.city,
          country: this.country,
          province: this.province,
          location: new Parse.GeoPoint({
            latitude: parseFloat(this.latitude),
            longitude: parseFloat(this.longitude)
          })
        })
        if (this.user) {
          this.toggleDialog({
            status: true,
            title: 'Success',
            message: 'Address updated successfully'
          })
        }
      }
    }
  },
  async created () {
    await this.getUser()
    this.addressOne = this.user.get('addressOne')
      ? this.user.get('addressOne')
      : ''
    this.addressTwo = this.user.get('addressTwo')
      ? this.user.get('addressTwo')
      : ''
    this.postalCode = this.user.get('postalCode')
      ? this.user.get('postalCode')
      : ''
    this.city = this.user.get('city') ? this.user.get('city') : ''
    this.province = this.user.get('province') || ''
    this.country = this.user.get('country') ? this.user.get('country') : ''
    this.address = ''
    this.latitude = this.user.get('latitude') ? this.user.get('latitude') : ''
    this.longitude = this.user.get('longitude')
      ? this.user.get('longitude')
      : ''
  }
}
</script>
